var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex justify-between items-center mb-8" },
    [
      _c("h2", { staticClass: "text-lg font-normal" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm.currentUser
        ? _c("EditButton", {
            attrs: { currentUser: _vm.currentUser },
            on: {
              edit: function ($event) {
                return _vm.$emit("edit")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }